<template>
  <div class="row radio-pill-row">
    <div
      v-for="(option, index) in options"
      :key="name + '-' + index"
      class="small-2 columns radio-pill-column"
    >
      <base-radio-button
        :id="name + '-' + index"
        :model-value="modelValue"
        :is-pill="true"
        :option="option"
        :name="name"
        :label="label"
        :option-label="optionLabel"
        :option-value="optionValue"
        :data-test-base-radio-button-pills="name"
        @input="(e) => $emit('update:modelValue', e.target._value)"
      />
    </div>
  </div>
</template>

<script>
import BaseRadioButton from './BaseRadioButton.vue';

export default {
  name: 'BaseRadioButtonPills',
  components: { BaseRadioButton },
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      type: [Number, String],
      default() {
        return null;
      }
    },
    options: {
      type: Array,
      default() {
        return [];
      }
    },
    name: {
      type: String,
      default() {
        return 'default-radio-button-pills-name';
      }
    },
    optionLabel: {
      type: String,
      default() {
        return 'label';
      }
    },
    label: {
      type: String,
      default() {
        return 'label';
      }
    },
    optionValue: {
      type: String,
      default() {
        return 'value';
      }
    }
  }
};
</script>
